// Keep call controls interactive above an open editor without closing its form.
export function placePhoneOverlay(el){
 const host=document.querySelector('#modal[open]')||document.body;
 if(el.parentElement!==host){try{el.hidePopover?.();}catch{}host.append(el);}
 try{el.showPopover?.();}catch{}
}
